<template>
  <ChipBadge :color="colorByStatus" :prepend-icon="iconByStatus" rounded>
    {{ t(`Reviews.product.campaign.table.statusLabel.${status}`, t('Reviews.product.campaign.table.statusLabel.unknown')) }}
  </ChipBadge>
</template>
<script setup lang="ts">
import { ChipBadge, iconDot } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { IncentivizationCampaignStatusEnum } from '@/gql/reviews'

const props = defineProps<{
  status: IncentivizationCampaignStatusEnum
}>()

const { t } = useI18n()

const iconByStatus = computed(() => {
  switch (props.status) {
    case IncentivizationCampaignStatusEnum.Active:
      return iconDot
    default:
      return undefined
  }
})

const colorByStatus = computed(() => {
  switch (props.status) {
    case IncentivizationCampaignStatusEnum.Active:
      return 'success'
    case IncentivizationCampaignStatusEnum.Pending:
      return 'yellow'
    default:
      return 'default'
  }
})
</script>
